import { Check } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { useCourses } from '@/providers';

export default function UnitPanel() {
  const { isChapterCompleted, toggleChapterCompleted } = useCourses();
  const actionLabel = isChapterCompleted
    ? 'Als unabgeschlossen markieren'
    : 'Als abgeschlossen markieren';

  return (
    <Tooltip title={actionLabel}>
      <IconButton
        disableRipple
        onClick={toggleChapterCompleted}
        size="large"
        aria-label="toggle completion status"
        sx={{
          backgroundColor: isChapterCompleted ? 'action.selected' : '',
        }}>
        <Check />
      </IconButton>
    </Tooltip>
  );
}
